<mat-toolbar>
  <div class="container-menu-logo">
    <mat-icon (click)="drawer.toggle()">menu</mat-icon>
    <img src="assets/images/logo-kn-white.svg" alt="logo KN" class="logo">
  </div>
  <app-profile-circle></app-profile-circle>
</mat-toolbar>

<div class="container">
  <mat-drawer-container class="mat-drawer-container" autosize>
    <mat-drawer #drawer class="sidenav" mode="side" [opened]="true">
      <mat-accordion>
        <mat-expansion-panel class="mat-elevation-z0 expansion-panel" hideToggle (opened)="openMenu = true"
                             (closed)="openMenu = false">
          @if (authenticationService.isAdmin || authenticationService.isApproverOrders) {
            <mat-expansion-panel-header>
              <button class="navigate-button" fxLayoutAlign="space-between center" (click)="removeLocalStorage()">
                {{ 'button.registrations' | translate }}
                <mat-icon color="accent">{{ openMenu ? 'keyboard_arrow_down' : 'keyboard_arrow_right' }}</mat-icon>
              </button>
            </mat-expansion-panel-header>
          }
          <div fxLayout="column" fxLayoutAlign="center start">
            <button mat-button class="navigate-button-menu" color="accent" routerLink="/items" (click)="removeLocalStorage()">
              {{ 'button.items' | translate }}
            </button>
            <button mat-button class="navigate-button-menu" color="accent" routerLink="/kits" (click)="removeLocalStorage()">
              {{ 'button.kits' | translate }}
            </button>
            <button mat-button class="navigate-button-menu" color="accent" routerLink="/suppliers" (click)="removeLocalStorage()">
              {{ 'button.suppliers' | translate }}
            </button>
            @if (authenticationService.isAdmin) {
              <button mat-button class="navigate-button-menu" color="accent" routerLink="/users" (click)="removeLocalStorage()">
                {{ 'button.users' | translate }}
              </button>
            }
          </div>
        </mat-expansion-panel>
      </mat-accordion>
      <button class="navigate-button" routerLink="/orders-dashboard" (click)="removeLocalStorage()">
        {{ 'button.ordersDashboard' | translate }}
      </button>
    </mat-drawer>
    <div class="sidenav-content">
      <router-outlet></router-outlet>
    </div>
  </mat-drawer-container>
</div>
